import { useSelector } from 'react-redux'
import React, { useMemo } from 'react'

import Drawer from '../../../../../../components/Drawer'
import ChangeHistory from '../../../../../../features/components/ChangeHistoryDrawer/ChangeHistory'

import useManageDrawer from '../../../../../../hooks/formHooks/useManageDrawer'

import { assetGroupsSelector } from '../../../../../../modules/selectors/assets'

import { TYPE_ASSET_GROUP } from '../../../../../../constants/changeHistory'
import { CHANGE_ASSET_GROUP_HISTORY } from '../../../../../../constants/forms'
import { GOOGLE_PLATFORM } from '../../../../../../constants/selectLists/platformList'

function AssetGroupsChangeHistory() {
  const assetGroups = useSelector(assetGroupsSelector)
  const { isFormOpen, handleFormClose, selectedEditItemId } = useManageDrawer({ formName: CHANGE_ASSET_GROUP_HISTORY })

  const selectedAssetGroupData = useMemo(
    () => selectedEditItemId && assetGroups.find(({ id }) => id === selectedEditItemId),
    [selectedEditItemId, assetGroups]
  )
  const historyDrawerTitle = `Change History for '${selectedAssetGroupData?.name}'`

  return (
    <Drawer isOpen={isFormOpen} onClose={handleFormClose} title={historyDrawerTitle || 'Change History'}>
      <ChangeHistory historyType={TYPE_ASSET_GROUP} platform={GOOGLE_PLATFORM} itemId={selectedEditItemId} />
    </Drawer>
  )
}

export default AssetGroupsChangeHistory
